import React from "react"
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core"
import { useEdicaoClienteContext } from "../context/useEdicaoClienteContext"

type CartoesClienteProps = {
    aberto: boolean
    aoFechar: () => void
}

export function CartoesCliente({ aberto, aoFechar }: CartoesClienteProps) {
    const { dados } = useEdicaoClienteContext()

    return (
        <Dialog open={aberto} onClose={aoFechar} fullWidth maxWidth="md">
            <DialogTitle>Cartões cadastrados — {dados.nome}</DialogTitle>
            <DialogContent>
                {dados.cartoes.length === 0 ? (
                    <Typography variant="body2" style={{ color: "#7f8c8d" }}>
                        O cliente não possui cartões cadastrados.
                    </Typography>
                ) : (
                    <TableContainer style={{ overflowX: "auto" }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Id</TableCell>
                                    <TableCell>Nome impresso</TableCell>
                                    <TableCell>Número</TableCell>
                                    <TableCell>Bandeira</TableCell>
                                    <TableCell>Banco</TableCell>
                                    <TableCell>CPF</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dados.cartoes.map(cartao => (
                                    <TableRow key={cartao.id}>
                                        <TableCell>{cartao.id}</TableCell>
                                        <TableCell>{cartao.nomeImpressoCartao || "-"}</TableCell>
                                        <TableCell>{cartao.numeroCartao || "-"}</TableCell>
                                        <TableCell>{cartao.bandeira || "-"}</TableCell>
                                        <TableCell>{cartao.codigoBanco || "-"}</TableCell>
                                        <TableCell>{cartao.cpf || "-"}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={aoFechar}>Fechar</Button>
            </DialogActions>
        </Dialog>
    )
}
